import { render, staticRenderFns } from "./LocaleStringModal.vue?vue&type=template&id=1ae41548&scoped=true&"
import script from "./LocaleStringModal.vue?vue&type=script&lang=js&"
export * from "./LocaleStringModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae41548",
  null
  
)

export default component.exports